import { settings } from './settings';

const urls = {
  assets: './app/static/'
};

export { urls };
